import { render } from "./pickUp.vue?vue&type=template&id=8c1ee4d2&scoped=true"
import script from "./pickUp.vue?vue&type=script&lang=js"
export * from "./pickUp.vue?vue&type=script&lang=js"

import "./pickUp.vue?vue&type=style&index=0&id=8c1ee4d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1ee4d2"]])

export default __exports__